import { Navigate, Outlet } from "react-router-dom";
import { LAB_TOKEN } from "./constants";

const Protected = () => {
  const token = localStorage.getItem(LAB_TOKEN);

  return token ? <Outlet /> : <Navigate to="/lab-login" />;
};

export default Protected;
